/**
 * @module navigation
 */
;(function NavigationDoubleTapToGo() {
    /**
     * Handle touch devices above 992px screen width
     * @method navigationDoubleTapToGo
     */
    function navigationDoubleTapToGo() {
        /**
         * local object availability
         * @type {navigationDoubleTapToGo}
         * @private
         */
        var _this = this

        /**
         * @type {number}
         */
        this.navigationBarBreakpoint = 992

        /**
         * @method cacheDom
         *  assign {jQuery|HTMLElement(s)} to object
         */
        this.cacheDom = function () {
            this.$navFirstLevelLinkElements = $('.nav-level-1.sub')
        }

        /**
         * @method triggerDoubleTapToGo
         * @returns {undefined}
         */
        this.triggerDoubleTapToGo = function () {
            var $windowWidth = $(window).width()
            if ($windowWidth >= _this.navigationBarBreakpoint) {
                $(_this.$navFirstLevelLinkElements).doubleTapToGo()
            }
        }

        /**
         * @method windowResize
         * @returns {undefined}
         */
        this.windowResize = function () {
            window.addEventListener('resize', _this.triggerDoubleTapToGo)
        }

        /**
         * @method init
         * @return {undefined}
         */
        this.init = function () {
            _this.cacheDom()
            _this.triggerDoubleTapToGo()
            _this.windowResize()
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.navigationDoubleTapToGo = navigationDoubleTapToGo
})()

$(document).ready(function () {
    new window.Creaton.navigationDoubleTapToGo()
})
